import { SiteImageSetting } from "./SiteImageSetting";

export const PageBackgroundSetting = () => (
    <section className="card-luxe p-8 grain space-y-4" data-testid="settings-page-background">
        <h3 className="font-serif-display text-2xl text-[#3D0C1F]">Page Background Photo</h3>
        <SiteImageSetting
            slot="page-bg"
            settingKey="page_bg_path"
            defaultSrc="/hero_girl.jpg"
            defaultLabel="Default girl photo"
            help="Shown on Pricing, Services, Promotions, Packages, Membership and About. Portrait photos with the subject on the right work best. JPEG, PNG or WebP, up to 8 MB."
        />
    </section>
);
